import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
// import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Api from "services/api";
// import { setRequesterIframeUrl } from "slices/requesterIframeUrlSlice";

const RequesterJoinRoom = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [iFrameURL, setiFrameURL] = useState();
  const [loading, setloading] = useState(false);



  useEffect(() => {
    const handleJoinVideoCall = async () => {
      setloading(true);
      try {
        const response = await Api.requesterJoinRoom(token);
        if (response?.status === 200) {
          const iframeUrl = response?.data?.data?.iframe_url;
          setiFrameURL(iframeUrl);
          console.log("Joined successfully:", response?.data?.data?.iframe_url);
          setloading(false);
        } else {
          const errorMsg =
            response?.data?.statusText ||
            response?.data?.message ||
            response?.data?.error;
          console.error("Failed to join:", errorMsg);
          toast.error(errorMsg, { className: "errorToast" });
        }
      } catch (err) {
        console.error("Error joining video call:", err);
      }
    };

    handleJoinVideoCall();
  }, [token]);

  console.log("iframe", iFrameURL)

  return (
    <div
      className="container-fluid d-flex flex-column align-items-center justify-content-center bg-light p-0"
      style={{ width: "100%", height: "100vh", overflow: "hidden" }}
    >
      {loading ? (
        <p>Loading video call...</p>
      ) : iFrameURL ? (
        <iframe
          title="100ms-app"
          allow="camera *;microphone *;display-capture *"
          src={iFrameURL}
          className="w-100 h-100 border-0"
        ></iframe>
      ) : (
        <p>No video call in progress.</p>
      )}
    </div>
  );
};

export default RequesterJoinRoom;
